import { createSlice } from "@reduxjs/toolkit";

import { logoutUserThunk, registerUserThunk } from "./thunks";
import { logInUserThunk } from "./thunks";
import { getAuthUserInfo } from "../../helpers/getAuthUserInfo";

interface AuthState {
  isLoading: boolean;
  isAuthorization: boolean;
  userInfo: any;
  apiError: string | null;
}

const authUserInfo: any = getAuthUserInfo();

const initialState: AuthState = {
  isLoading: false,
  isAuthorization: !!authUserInfo,
  userInfo: authUserInfo,
  apiError: null,
};

export const authLogoSlice = createSlice({
  name: "authLogoSlice",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(logInUserThunk.pending, state => {
        state.isLoading = true;
        state.apiError = null;
      })
      .addCase(logInUserThunk.fulfilled, (state, payload) => {
        state.isLoading = false;
        state.isAuthorization = true;
        state.apiError = null;
        state.userInfo = payload;
      })
      .addCase(logInUserThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.apiError = action.error.message || "Login failed";
      })
      .addCase(registerUserThunk.pending, state => {
        state.isLoading = true;
        state.apiError = null;
      })
      .addCase(registerUserThunk.fulfilled, state => {
        state.isLoading = false;
        state.isAuthorization = true;
        state.apiError = null;
      })
      .addCase(registerUserThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.apiError = action.error.message || "Registration failed";
      })
      .addCase(logoutUserThunk.fulfilled, state => {
        state.isAuthorization = false;
        state.userInfo = null;
        state.apiError = null;
      });
  },
});

export default authLogoSlice.reducer;
